import React from "react";
import { FaHatCowboy,FaChalkboardTeacher } from "react-icons/fa";
import { VscBook } from "react-icons/vsc";
import { GiTeacher } from "react-icons/gi";
import { motion as m } from "framer-motion";
import { Helmet } from "react-helmet";
import Card from 'react-bootstrap/Card';
import { IoBookSharp } from "react-icons/io5";

const ManagementSciences = () => {
    return (
        <m.div
            initial={{ scaleY: 0 }}
            animate={{ scaleY: 1 }}
            exit={{ scaleY: 0 }}
            transition={{ duration: 0.5 }}
        >
            <>
                <Helmet>
                    <title>Department of Management Sciences |</title>
                </Helmet>
                {/* <Navcomponent /> */}
                <section id="courses" className="border-green">
                    <div className="course-mainheading">
                        <h1 className="font-tomatosemibold text-orange text-center"><IoBookSharp /> PROGRAM</h1>
                    </div>
                </section>
                <section>
                    <div className="container">
                        <div className="row justify-center">
                            <div className="col-md-6">
                                <div className="course-div">
                                    <Card className="course-card">
                                        <div className="relative">
                                            <div className="courseimg-parent">
                                                <Card.Img variant="top" className="courseimg" src={'./assets/images/bsmanagement.png'} alt="course" />
                                            </div>
                                            <div className="course-pill">
                                                <FaHatCowboy />  Management Sciences
                                            </div>
                                        </div>
                                        <Card.Body className="course-cardbody">
                                            <Card.Title className="course-cardtitle">Bachelor of Business Administration (Hons)</Card.Title>
                                            <Card.Text className="caourse-detailpara">
                                            The BBA program at the Department of Management Sciences (DMS) provides a comprehensive education in various business disciplines, including accounting & finance, human resource management, supply chain management, and marketing. This program is designed to offer flexible, inclusive, and practical courses that are directly applicable to real-world scenarios. With a vision to be a globally recognized center of excellence, DMS aims to empower students to become global leaders and catalysts for positive change.
                                            </Card.Text>
                                            <div className="book float-right">
                                                <VscBook />
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </div>
                            </div>
                           
                        </div>
                    </div>
                </section>
              
                {/* <Footer /> */}
            </>
        </m.div>
    )


}

export default ManagementSciences